import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const Close = createSvgIcon(
  <path d="M12 10.409 1.612.02.022 1.612 10.408 12 .021 22.387l1.591 1.591L12 13.591l10.387 10.387 1.591-1.59L13.591 12 23.979 1.612 22.387.022 12 10.408Z" />,
  'Close'
);

export { Close };
